export function generateDynamicSummary(nodes) {
  if (!nodes || nodes.length === 0) {
    return "Nenhum elemento foi adicionado até o momento.";
  }

  const byDomain = {
    context: [],
    process: [],
    values: [],
  };

  nodes.forEach((n) => {
    byDomain[n.domain]?.push(n);
  });

  const centralNodes = nodes.filter((n) => n.central);

  const parts = [];

  // Visão geral
  parts.push(
    `Até o momento, foram registrados ${nodes.length} elementos relevantes para a compreensão do caso.`
  );

  // Distribuição por domínio
  if (byDomain.context.length > 0) {
    parts.push(
      `${byDomain.context.length} relacionados à história e ao contexto.`
    );
  } else {
    parts.push(
      `Ainda não há elementos explicitamente relacionados à história ou ao contexto.`
    );
  }

  if (byDomain.process.length > 0) {
    parts.push(`${byDomain.process.length} relacionados a processos em jogo.`);
  } else {
    parts.push(
      `Poucos ou nenhum elemento foi relacionado diretamente a processos até o momento.`
    );
  }

  if (byDomain.values.length > 0) {
    parts.push(
      `${byDomain.values.length} relacionados a valores, anseios ou tensões.`
    );
  } else {
    parts.push(
      `Elementos ligados a valores e direções de vida ainda aparecem pouco.`
    );
  }

  // Centralidade
  if (centralNodes.length > 0) {
    const centralTexts = centralNodes
      .slice(0, 3)
      .map((n) => `"${n.text}"`)
      .join(", ");

    parts.push(
      `Alguns elementos foram marcados como mais centrais neste momento, incluindo ${centralTexts}.`
    );
  }

  // Fechamento
  parts.push(
    "Este resumo é provisório e pode mudar conforme novos elementos forem adicionados ou reorganizados."
  );

  return parts.join(" ");
}
